<!--
   Created by qing on 2021/7/3
   Des:
-->
<template>

  <van-cell class="ry-form__item-iframe" v-if="$store.getters.env !== ENV_TYPE_SMALLPROGRAM">
    <template slot="title">
      <span class="title">{{current.title}}</span>
    </template>
    <template slot="label">

      <template v-if="current.fieldHint">
        <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
        <div
          v-else
          class="ql-editor"
          v-html="current.fieldHint">
        </div>
      </template>

      <div
        class="iframe-container"
        style="max-width: 100%"
        :style="iframeStyle"
        v-html="current.codeInfo">
      </div>
    </template>

  </van-cell>

</template>

<script>
  import {current} from './mixin'
  import {ENV_TYPE_SMALLPROGRAM} from "../../store/types";

  export default {
    mixins: [current],
    data() {
      return {
        ENV_TYPE_SMALLPROGRAM,
        src: ''
      }
    },
    created() {

    },
    computed: {

      iframeStyle() {

        const width = '100%'
        const height = `auto`

        return {
          width,
          height,
          aspectRatio: `${Number(this.current.realWidth)} / ${Number(this.current.realHeight)}`
        }
      }
    },
    methods: {}
  }
</script>

<style lang="less">

  .ry-form__item-iframe {

    .iframe-container {

      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
